import { render, staticRenderFns } from "./paketekhizmet.vue?vue&type=template&id=22131fd8"
import script from "./paketekhizmet.vue?vue&type=script&lang=js"
export * from "./paketekhizmet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports